import { gql } from "@apollo/client";
import { INTERVIEW_QUESTION_FIELDS, INTERVIEW_QUESTION_AI_VIDEO_TASK_FIELDS } from "graphql/fragments";

const ADD_MISSION_INTERVIEW = gql`
  mutation AddMissionInterview($input: AddMissionInterviewInput!) {
    addMissionInterview(input: $input) {
      missionInterview {
        id
      }
    }
  }
`;

const ADD_INTERVIEW = gql`
  mutation AddInterview($input: AddInterviewInput!) {
    addInterview(input: $input) {
      interview {
        id
        name
        categories {
          id
          name
          uuid
        }
      }
    }
  }
`;

const UPDATE_INTERVIEW = gql`
  mutation UpdateInterview($input: UpdateInterviewInput!) {
    updateInterview(input: $input) {
      interview {
        id
        name
        categories {
          id
          name
          uuid
        }
      }
    }
  }
`;

const DUPLICATE_INTERVIEW = gql`
  mutation DuplicateInterview($input: DuplicateInterviewInput!) {
    duplicateInterview(input: $input) {
      interview {
        id
        name
        categories {
          id
          name
          uuid
        }
      }
    }
  }
`;

const REMOVE_INTERVIEW = gql`
  mutation RemoveInterview($input: RemoveInterviewInput!) {
    removeInterview(input: $input) {
      id
    }
  }
`;

const UPDATE_INTERVIEW_QUESTIONS = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation updateInterviewQuestions($input: UpdateInterviewQuestionsInput!) {
    updateInterviewQuestions(input: $input) {
      interview {
        id
        questions {
          ...InterviewQuestionFields
        }
      }
    }
  }
`;

const UPLOAD_INTERVIEW_QUESTION_VIDEO = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation uploadInterviewQuestionVideo($input: UploadInterviewQuestionVideoInput!) {
    uploadInterviewQuestionVideo(input: $input) {
      interview {
        id
        questions {
          ...InterviewQuestionFields
        }
      }
    }
  }
`;

const UPLOAD_INTERVIEW_INTRO_VIDEO = gql`
  mutation uploadInterviewIntroVideo($input: UploadInterviewIntroVideoInput!) {
    uploadInterviewIntroVideo(input: $input) {
      interview {
        id
        introVideoUrl
      }
    }
  }
`;

const SUBMIT_INTERVIEW_QUESTION_AI_VIDEO_GENERATION = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  ${INTERVIEW_QUESTION_AI_VIDEO_TASK_FIELDS}
  mutation submitInterviewQuestionAiVideoGeneration($input: SubmitInterviewQuestionAiVideoGenerationInput!) {
    submitInterviewQuestionAiVideoGeneration(input: $input) {
      task {
        ...InterviewQuestionAiVideoTaskFields
      }
      interviewQuestion {
        ...InterviewQuestionFields
      }
    }
  }
`;

const CONFIRM_INTERVIEW_QUESTION_AI_VIDEO_GENERATION = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation confirmInterviewQuestionAiVideoGeneration($input: ConfirmInterviewQuestionAiVideoGenerationInput!) {
    confirmInterviewQuestionAiVideoGeneration(input: $input) {
      interviewQuestion {
        ...InterviewQuestionFields
      }
    }
  }
`;

const CANCEL_INTERVIEW_QUESTION_AI_VIDEO_GENERATION = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  mutation cancelInterviewQuestionAiVideoGeneration($input: CancelInterviewQuestionAiVideoGenerationInput!) {
    cancelInterviewQuestionAiVideoGeneration(input: $input) {
      interviewQuestion {
        ...InterviewQuestionFields
      }
    }
  }
`;

export {
  ADD_MISSION_INTERVIEW,
  UPDATE_INTERVIEW,
  REMOVE_INTERVIEW,
  ADD_INTERVIEW,
  DUPLICATE_INTERVIEW,
  UPDATE_INTERVIEW_QUESTIONS,
  UPLOAD_INTERVIEW_QUESTION_VIDEO,
  UPLOAD_INTERVIEW_INTRO_VIDEO,
  SUBMIT_INTERVIEW_QUESTION_AI_VIDEO_GENERATION,
  CANCEL_INTERVIEW_QUESTION_AI_VIDEO_GENERATION,
  CONFIRM_INTERVIEW_QUESTION_AI_VIDEO_GENERATION,
};
